"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const Title_1 = __importDefault(require("antd/lib/typography/Title"));
const suiteCollapseStyle_1 = require("../suiteCollapseStyle");
require("../SuiteTabs.scss");
const SuiteFormRequired_1 = __importDefault(require("../suiteForm/SuiteFormRequired"));
const SuiteForm_1 = __importDefault(require("../suiteForm/SuiteForm"));
const CheckBoldIcon_1 = __importDefault(require("mdi-react/CheckBoldIcon"));
const ordinalNames = ['Primeiro', 'Segundo', 'Terceiro', 'Quarto', 'Quinto'];
const guestFieldsToValidate = ['fullname', 'documentGuest', 'birthday', 'email', 'phone'];
const SuiteTabsPreCheckin = ({ field, guestsQty, form, formKey = 'suites', requiredGuestsCheckin, setIsRequiredCheckin, tabActive = '0', }) => {
    const [validGuests, setValidGuests] = (0, react_1.useState)(Array(guestsQty - 1).fill(true));
    const { TabPane } = antd_1.Tabs;
    const [tabActivePane, setTabActivePane] = (0, react_1.useState)(tabActive);
    (0, react_1.useEffect)(() => {
        if (!validGuests.length)
            setValidGuests(Array(guestsQty - 1).fill(true));
    }, [guestsQty]);
    const changeTab = (0, react_1.useCallback)(key => {
        setTabActivePane(key);
    }, []);
    (0, react_1.useEffect)(() => {
        setTabActivePane(tabActive);
    }, [tabActive]);
    function setValidGuest(key, value) {
        setValidGuests(validGuests.map((isValid, index) => (key === index ? value : isValid)));
    }
    function validateAllGuests() {
        const guests = form.getFieldValue([formKey, field.key, 'guests']);
        const fieldsToValidate = [
            ...guests.reduce((arrayTotal, guest, index) => [
                ...arrayTotal,
                ...guestFieldsToValidate.map(fieldName => [formKey, field.key, 'guests', index, fieldName]),
            ], []),
        ];
        form.validateFields(fieldsToValidate).then(() => {
            const newValidGuests = validGuests.map(() => true);
            setValidGuests(newValidGuests);
        }).catch(response => {
            var _a;
            const newValidGuests = validGuests.map(() => true);
            if ((_a = response.errorFields) === null || _a === void 0 ? void 0 : _a.length) {
                response.errorFields.forEach((error) => {
                    newValidGuests[error.name[3]] = false;
                });
            }
            setValidGuests(newValidGuests);
        });
    }
    return (react_1.default.createElement("div", { className: "SuiteTabs" },
        react_1.default.createElement(suiteCollapseStyle_1.FormBody, { showForm: true },
            react_1.default.createElement(Title_1.default, { level: 5 }, "Primeiro H\u00F3spede"),
            react_1.default.createElement("div", { style: { display: 'block' } },
                react_1.default.createElement(SuiteFormRequired_1.default, { field: field, formKey: formKey })),
            react_1.default.createElement(antd_1.Divider, null),
            react_1.default.createElement(antd_1.Form.List, { name: [field.key, 'guests'] }, guestFields => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(antd_1.Tabs, { type: "card", activeKey: tabActivePane, onChange: changeTab, className: "guests-tabs" }, guestFields.map((guestField, index) => (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(TabPane, { tab: react_1.default.createElement("div", { onClick: validateAllGuests, className: `tabPaneDiv ${requiredGuestsCheckin[index] ? 'tabPaneStyleNotEmpty' : ''}` },
                            `${ordinalNames[index + 1]} Hóspede`,
                            (requiredGuestsCheckin[index] && validGuests[index]) ? react_1.default.createElement("div", { className: "valid-icon" },
                                react_1.default.createElement(CheckBoldIcon_1.default, null)) : ''), key: guestField.key, className: "tabPaneStyle" },
                        react_1.default.createElement(Title_1.default, { level: 5 }, `${ordinalNames[index + 1]} Hóspede`),
                        react_1.default.createElement("div", { style: { display: 'block' } },
                            react_1.default.createElement(SuiteForm_1.default, { form: form, formKey: formKey, field: field, isRequired: requiredGuestsCheckin[index], setIsRequired: (value) => setIsRequiredCheckin(index, value), guestField: guestField })))))))))))));
};
exports.default = SuiteTabsPreCheckin;
